
import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../redux/initialStoreState";
import { useDispatchWrapper, useQueryParms } from "../../../../../hooks";
import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../constants/enums";
import { StandadCard } from "../../../../../components/Cards";
import { TabsList } from "../../../../../components/Tabs/TabsList";
import { AccountCircle, AdminPanelSettings, ChecklistOutlined } from "@mui/icons-material";
import { TabPanel } from "../../../../../components/Tabs/TabPanel";
import { useNavigate, useOutletContext } from "react-router-dom";
import { CommAutomobileMarketingList } from "./CommAutoMarketing/CommAutoMarketingList";
import { CommAutoBinderList } from "./CommAutoBinder/CommAutoBinderList";
import { CommAutoChecklistTab } from "./CommAutoChecklist/CommAutoChecklistTab";
import { fetchCommAutomobileCustomerInfoAsync } from "../../../../../redux/commAutoPolicy/commAutoBasicDetails/commAutoBasicDetailsActions";
import { fetchCommAutoChecklistSavedStatusAsync } from "../../../../../redux/commAutoPolicy/commAutoMarketingHistory/commAutoMarketingHistoryActions";
import { PageContainer } from "../../../../../components/container/PageContainer";

export const CommAutoMarketingRoot = () => {
  const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];
  const { customerInfo } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.basicDetails
  );
  const checklistSaved = useSelector(
    (storeState: IStoreState) =>
      storeState.commAuto.marketing.checklist.savedStatus
  );
  const { getParm } = useQueryParms();
  const tabValue = getParm("tab");
  const selectedTab = tabValue ? Number(tabValue) : 0;

  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    navigate(
      `/comm-automobile-policy/${customerId}/marketing-tab/${customerPolicyId}?tab=${newValue}`
    );
  };

  const handleChecklistSaved = () => {};

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchCommAutomobileCustomerInfoAsync(customerPolicyId));
      dispatch(fetchCommAutoChecklistSavedStatusAsync(customerPolicyId));
    }
  }, [customerPolicyId]);

  React.useEffect(() => {
    if (selectedTab === 2 && !checklistSaved) {
      navigate(
        `/comm-automobile-policy/${customerId}/marketing-tab/${customerPolicyId}?tab=1`
      );
    }
  }, [selectedTab, checklistSaved]);

  return (
    <PageContainer title={"Marketing"} description={"Marketing"}>
      <PageLoader
        loading={customerInfo.loading === LoadState.InProgress}
        error={customerInfo.error ? { message: customerInfo.error } : null}
      >
        <StandadCard>
          <TabsList
            sx={{ mb: 1 }}
            varaint="fullWidth"
            selectedTab={selectedTab}
            tabs={[
              {
                label: "Marketing",
                icon: <AccountCircle />,
              },
              {
                label: "Checklist",
                icon: <ChecklistOutlined />,
              },
              {
                label: "Binder",
                icon: <AdminPanelSettings />,
                disabled: !checklistSaved,
              },
            ]}
            onChange={handleChange}
          />
          <TabPanel value={selectedTab} index={0}>
            <CommAutomobileMarketingList />
          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            <CommAutoChecklistTab
              customerId={customerId}
              customerPolicyId={customerPolicyId}
              onSaveSuccess={handleChecklistSaved}
            />
          </TabPanel>
          <TabPanel value={selectedTab} index={2}>
            <CommAutoBinderList checklistSaved={checklistSaved} />
          </TabPanel>
        </StandadCard>
      </PageLoader>
    </PageContainer>
  );
};
